const topicTags = [
  { label: '红桃视频', heat: '热门', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { label: '樱桃视频', heat: '推荐', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { label: '茄子视频', heat: '热播', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { label: '糖心视频', heat: '热播', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { label: '高清全集', heat: '推荐', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { label: '热门短剧', heat: '热门', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { label: '古装大剧', heat: '', color: 'bg-background-100 text-foreground-700 border-background-200' },
  { label: '悬疑推理', heat: '', color: 'bg-background-100 text-foreground-700 border-background-200' },
  { label: '综艺娱乐', heat: '', color: 'bg-background-100 text-foreground-700 border-background-200' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            大家都在关注的热门标签与内容方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((item, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 hover:scale-105 ${item.color}`}
            >
              {item.label}
              {item.heat && (
                <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                  item.heat === '热门' ? 'bg-accent-500/10 text-accent-600' :
                  item.heat === '热播' ? 'bg-secondary-500/10 text-secondary-600' :
                  'bg-primary-500/10 text-primary-600'
                }`}>
                  {item.heat}
                </span>
              )}
            </span>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-xs text-foreground-500">
            以上标签基于全网用户搜索热度实时生成，每日自动更新
          </p>
        </div>
      </div>
    </section>
  );
}